import React, { ChangeEvent, useCallback } from 'react';
import { SystemStyleObject } from '@chakra-ui/react';
import { Button, Colors, Icon, Input } from '@mercator-gcp/grout';

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  showClear?: boolean;
  onClear?: () => void;
  disabled?: boolean;
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
  sx?: SystemStyleObject;
}

const SearchInput = ({
  value,
  onChange,
  placeholder = 'Search',
  showClear,
  onClear,
  disabled,
  onKeyDown,
  sx,
}: SearchInputProps) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  const handleClear = useCallback(() => {
    onChange('');
    onClear?.();
  }, [onChange, onClear]);

  const shouldShowClear = showClear !== undefined ? showClear : value.length > 0;

  return (
    <Input
      value={value}
      onChange={handleChange}
      onKeyDown={onKeyDown}
      placeholder={placeholder}
      aria-label={placeholder}
      disabled={disabled}
      startAdornment={<Icon fill={Colors.TextQuiet} name={Icon.Name.Search} />}
      sx={sx}
      endAdornment={
        shouldShowClear ? (
          <Button
            variant="unstyled"
            onClick={handleClear}
            style={{ cursor: 'pointer', display: 'flex' }}
          >
            <Icon name={Icon.Name.CloseX} size={16} fill={Colors.TextQuiet} />
          </Button>
        ) : undefined
      }
    />
  );
};

export default SearchInput;
